import moment from 'moment';
import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submissin-publication-paged-request';
import { IUserSendSubimissonPublicationResponse } from '../../../../model/sep/submission-publications/response/user-send-submission-publication-response';
import { IStatusSubimissonPublicationResponse } from '../../../../model/sep/submission-publications/response/status-submission-publication-response';

export type SubmissionPublicationSearchState = {
  users: IUserSendSubimissonPublicationResponse[];
  status: IStatusSubimissonPublicationResponse[];
  datesParameters: {
    starDatePicker: moment.Moment;
    endDatePicker: moment.Moment;
  };
  parameters: ISubmissionPublicationPagedRequest;
  submissionPublicationId?: number;
};

export enum ACTION_TYPES {
  setUsers = 'setUsers',
  setStatus = 'setStatus',
  setDatesParameters = 'setDatesParameters',
  setParameters = 'setParameters',
  updateParameter = 'updateParameter',
  setSubmissionPublicationId = 'setSubmissionPublicationId',
}

export const SubmissionPublicationSearchReducer = (state: SubmissionPublicationSearchState, action: any): SubmissionPublicationSearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setUsers:
      return {
        ...state,
        users: payload,
      };
    case ACTION_TYPES.setStatus:
      return {
        ...state,
        status: payload,
      };
    case ACTION_TYPES.setDatesParameters:
      return {
        ...state,
        datesParameters: payload,
      };
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.setSubmissionPublicationId:
      return {
        ...state,
        submissionPublicationId: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
